export const APP_STORE_PREFIX_CONSTANT = 'LI/SUB-MODULE/';
